import React from 'react';

import './MenuEmptyPlaceholder.css';

const MenuEmptyPlaceholder = () => (
  <div className="price-menu-links-empty-placeholder__component">
    <div className="image-wrapper" />
  </div>
);

export default MenuEmptyPlaceholder;
